import { render, staticRenderFns } from "./RDataImage.vue?vue&type=template&id=3385f89c&scoped=true&"
import script from "./RDataImage.vue?vue&type=script&lang=js&"
export * from "./RDataImage.vue?vue&type=script&lang=js&"
import style0 from "./RDataImage.vue?vue&type=style&index=0&id=3385f89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385f89c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VListItemAvatar,VProgressCircular,VRow})
